<a
  *ngIf="navItem.type === navItemType.standard"
  [routerLink]="navItem.link"
  (click)="navItemClicked.emit()"
  class="header-item"
  routerLinkActive="nav-active">
  <div class="image-border" *ngIf="state === navImageState.loaded && image?.url">
    <img
      class="image-icon"
      [src]="image?.url | bypassUrlSafety"
      [alt]="'Uploaded image, original filename was ' + image?.originalFilename" />
  </div>
  <svg-icon *ngIf="!image?.url && navItem.icon" [src]="navItem.icon"></svg-icon>
  <div class="header-title">
    {{ navItem.title }}
  </div>
</a>

<kp-quick-actions
  *ngIf="navItem.type === navItemType.quickActions"
  [quickActionsOpen]="quickActionsOpen"
  (quickActionsToggled)="quickActionsToggled.emit($event)"></kp-quick-actions>
